export const authConfig = {
  meEndpoint: "/auth/academy/me",
  loginEndpoint: "/auth/academy/login",
  forgotPasswordEndpoint: "/auth/academy/forgot-password",
  requestOTPEndpoint: "/auth/academy/request-otp",
  otpLoginEndpoint: "/auth/academy/otp-login",
  resetPasswordEndpoint: "/auth/academy/reset-password",
  changePasswordEndpoint: "/auth/academy/change-password",
  storageTokenKeyName: "accessToken",
};
